/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import Iframe from "react-iframe";
import layoutConf from "../../config/layoutConf";
import apiClient from "../../lib/common/apiClient";
/**
 * @COMPONENT_NAME BarcodePrintFormManagement
 * @DESCRIPTION 바코드 출력 폼을 관리하는 화면 컴포넌트
 *
 * @PASSTHROUGH_PROPS
 *   - {Object} api - 바코드 출력 폼 API 객체
 *   - {Object} grid - 바코드 출력 폼 그리드 객체 참조
 *   - {Object} selectedGrid - 선택된 바코드 출력 폼 정보
 *   - {String} iframeUrl - 바코드 출력 양식을 보여줄 iframeUrl
 *
 * @CALLBACKS
 *   - {Function} handleResize - 화면 크기 변경 시 호출되는 콜백
 *   - {Function} onApiInitialized - API 초기화 콜백-
 *   - {Function} onInitialized - 그리드 초기화 콜백
 *  */

const BarcodePrintForm = () => {
    const table = "BarcodePrintForm";
    const [height, setHeight] = useState(0);

    const [api, setApi] = useState();
    const [grid, setGrid] = useState();
    const [selectedGrid, setSelectedGrid] = useState();
    const [iframeUrl, setIframeUrl] = useState("");

    const { t } = useTranslation();

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (grid) {
            const handleGridSelection = (grid, event) => {
                const selectedItem = grid.selectedItems?.length ? grid.selectedItems[0] : [];
                setSelectedGrid(selectedItem);
            };
            grid.selectionChanged.addHandler(handleGridSelection);
            grid.itemsSourceChanged.addHandler(handleGridSelection);
            return () => {
                if (grid && !grid.isDestroyed) {
                    grid.selectionChanged.removeHandler(handleGridSelection);
                    grid.itemsSourceChanged.removeHandler(handleGridSelection);
                }
            };
        }
    }, [grid]);

    useEffect(() => {
        if (selectedGrid) {
            console.log(selectedGrid);
            let url =
                process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging"
                    ? `/report/CommonReport`
                    : `http://localhost:8080/report/CommonReport`;

            let form = new FormData();
            let apiData = {
                title: "BarcodePrintForm",
                reportName: selectedGrid.fileName,
                reportData: selectedGrid.fileJsonData,
            };

            form.append("deleted", []);
            form.append("json", JSON.stringify(apiData));
            apiClient
                .post(url, form, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    let blob = new Blob([response.data], {
                        type: "text/html;charset=utf-8;",
                    });

                    let url = window.URL.createObjectURL(blob);

                    setIframeUrl(url);
                })
                .catch((error) => {
                    setIframeUrl("");
                });
        } else {
            setIframeUrl("");
        }
    }, [selectedGrid]);

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };

    // const notifySuccess = (msg) => {
    //     setNotification({
    //         severity: "success",
    //         msg: msg,
    //         open: true,
    //     });
    // };

    // const notifyFailure = (msg) => {
    //     setNotification({
    //         severity: "error",
    //         msg: msg,
    //         open: true,
    //     });
    // };

    // const notifyWarning = (msg) => {
    //     setNotification({
    //         severity: "warning",
    //         msg: msg,
    //         open: true,
    //     });
    // };

    // const onSuccess = (msg, position) => {
    //     notifySuccess(msg);
    //     api?.refresh();
    // };

    // const onFailure = (reason) => {
    //     notifyFailure(reason);
    // };

    // const onNotifyWarning = (msg) => {
    //     notifyWarning(msg);
    //     api?.refresh();
    // };

    return (
        <div style={{ height: height }}>
            <ReflexContainer orientation="vertical">
                <ReflexElement flex={0.4}>
                    <BasicCrudScreenType
                        id={table}
                        table={table}
                        view={table}
                        onInitialized={onInitialized}
                        onApiInitialized={onApiInitialized}
                        noExcel
                        noFilter
                    />
                </ReflexElement>

                <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />

                <ReflexElement flex={0.6} minSize={300}>
                    <div
                        style={{
                            height: "100%",
                            padding: "10px",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <div
                            style={{
                                marginBottom: "10px",
                                fontSize: "16px",
                                fontWeight: "bold",
                            }}
                        >
                            {t("barcodePrintForm.preview")}
                        </div>
                        {iframeUrl ? (
                            <Iframe url={iframeUrl} width="100%" height="100%" display="block" position="relative" />
                        ) : (
                            <div
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#f5f5f5",
                                    color: "#666",
                                }}
                            >
                                {t("barcodePrintForm.fileNotFound")}
                            </div>
                        )}
                    </div>
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
};

export default BarcodePrintForm;
